module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_04@2x-8ab83e65d9cef3d77fccb0208bef1665.webp";